import { mapMutations, mapGetters, mapActions } from "vuex";
import Banner from "@/modules/promotions/banner/index.vue";
import {} from "@/store/mutation-types";

import timer from "@/components/timer/index.vue";
import StarRating from "vue-star-rating";
import { Carousel, Slide } from "vue-carousel";
import moment from "moment";

export default {
    name: "discount-product-mobile",
    props: ["sliders", "items", "product", "time"],
    data() {
        return {
            currentSlide: 0,
            discount: false,
        };
    },
    components: {
        timer,
        StarRating,
        Carousel,
        Slide,
        Banner,
    },
    computed: {
        ...mapGetters({
            basket: `basket/basket`,
            count: `basket/count`,
            popupFastBuy: `card/popupFastBuy`,
            isAuthenticated: `auth/isAuthenticated`,
            getList: `promotions/getList`,
        }),
        getUnit() {
            if (this.product.unit !== null) {
                return "/" + this.product.unit;
            }
        },
        getCurrentPrice() {
            if (this.product.sale_start) {
                let period = `${this.product.sale_start.slice(0, -8)},${this.product.sale_end.slice(0, -8)}`;
                let currentDate = new Date().toISOString().split("T")[0];
                let dates = period.split(",");
                let result = moment(currentDate).isBetween(dates[0], dates[1], null, "()");

                if (!result && this.product.discount_price === 0) {
                    return this.product.price;
                } else {
                    this.discount = true;
                    return this.product.discount_price;
                }
            } else {
                return this.product.price;
            }
        },
    },
    methods: {
        ...mapActions({
            addFavourite: `favorites/ADD_PRODUCT_TO_FAVORITE`,
        }),
        ...mapMutations({
            addBasket: `basket/ADD_ITEM_TO_BASKET`,
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        addToBasket(product) {
            this.addBasket({
                min_price: this.product.min_price,
                select_count: this.count,
                select_price: product.discount_price ? product.discount_price : product.price,
                ...product,
            });
            this.$toasted.success(this.$t("successAddBasket"));
        },
        changePopup(status) {
            this.changeFastBuy({
                show: status,
                product_id: this.item.id,
                count: this.item.select_count ? this.item.select_count : 1,
            });
        },
        addFavourites(item) {
            if (this.isAuthenticated) {
                this.addFavourite(item)
                    .then(() => {
                        this.$toasted.success(this.$t("successAddFavourites"));
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 422) {
                            console.log(this.validationErrors);
                        }
                    });
            } else {
                this.changePopupRegister({ show: true, isRedirect: false });
            }
        },
        changeArrow(value) {
            const carousel = this.$refs["slider-items"];
            const currentPage = carousel.currentPage;
            const pageCount = carousel.pageCount;
            if (value === "prev") {
                currentPage !== 0 ? carousel.goToPage(currentPage - 1) : carousel.goToPage(pageCount - 1);
            } else {
                currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0);
            }
        },
        gotToSlide(index) {
            const carousel = this.$refs["slider-items"];
            carousel.goToPage(index);
        },
        pageChange(slide) {
            this.currentSlide = slide;
        },
    },
};
